import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link, useLocation } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import Menubar from "../common/Menubar";
import EnquiryNow from "../common/EnquiryNow";
import Allinone from "../common/Allinone";
import Brochure from "../../Images/Brochure/ISBM_PROSPECTUS.pdf";
import { Container, Row, Col, Breadcrumb, Modal } from "react-bootstrap";
// import Brochure from "../../Images/Brochure/ISBM_PROSPECTUS.pdf";
// import Prospectus from "../../Images/Brochure/Yoga & Naturopathy.pdf";

const CourseDetails = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [show, setShow] = useState(false);
  const { courseName } = useParams();
  const [course, setCourse] = useState(null);
  const [schoolName, setSchoolName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [courseList, setCourseList] = useState([]);
  const [careerList, setCareerList] = useState([]);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/courses/${courseName}`
        );
        const courseData = response.data.data[0];
        setCourse(courseData);
        setSchoolName(courseData.school_name);
      } catch (error) {
        setError("Error fetching course details");
        console.error("Error fetching course details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseDetails();
  }, [courseName]);

  useEffect(() => {
    if (schoolName) {
      const fetchCourseList = async () => {
        try {
          const response = await axios.get(
            `https://isbmuniversity.edu.in/admin-portal/coursesList/${schoolName}`
          );
          setCourseList(response.data.data);
        } catch (error) {
          console.error("Error fetching courseList:", error);
        }
      };

      fetchCourseList();
    }
  }, [schoolName]);

  useEffect(() => {
    if (schoolName) {
      const fetchCareerList = async () => {
        try {
          const response = await axios.get(
            `https://isbmuniversity.edu.in/admin-portal/career_opportunity/${schoolName}`
          );
          setCareerList(response.data.careers);
        } catch (error) {
          console.error("Error fetching careerList:", error);
        }
      };

      fetchCareerList();
    }
  }, [schoolName]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  // Assuming `course.specialization` contains HTML string
  // Parse it to extract the list items if it's raw HTML
  const parseSpecializations = (html) => {
    // Create a temporary element to parse HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.querySelectorAll("li");
  };

  const specializationItems = parseSpecializations(course.specialization);

  return (
    course && (
      <React.Fragment>
        <title>{course.metatitle}</title>
        <meta name="description" content={course.metadesc} />
        <meta
          name="SearchEngines"
          content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
              DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
        />
        <meta name="Robots" content="INDEX, FOLLOW" />
        <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
        <meta name="Robots" content="INDEX,ALL" />
        <meta name="YahooSeeker" content="INDEX, FOLLOW" />
        <meta name="msnbot" content="INDEX, FOLLOW" />
        <meta name="googlebot" content="Default, follow" />
        <meta name="owner" content="isbmuniversity.edu.in/" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="2 days" />
        <meta property="og:title" content={course.metatitle} />
        <meta property="og:description" content={course.metadesc} />
        <meta
          property="og:url"
          content={`https://isbmuniversity.edu.in/course-details/${course.name}`}
        />
        <meta
          property="og:image"
          content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
        />
        <meta property="og:image:alt" content="ISBM University" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="ISBM University" />
        <meta name="twitter:title" content={course.metatitle} />
        <meta name="twitter:description" content={course.metadesc} />
        <meta
          name="twitter:image:src"
          content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.webp"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@ISBMUniversity" />
        <meta name="twitter:creator" content="@ISBMUniversity" />
        <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
        <meta property="twitter:account_id" content="758619542734053376" />
        <Topnav />
        <div
          className={`innerbackimage position-relative section-hero-banner ${course.banner}`}
          aria-label="Best University in Chhattisgarh"
        >
          <div class="bannerShape">
            <div class="bannerDetails" id="bannerDetails">
              <h1 class="fw-bold text-white mb-3">{course.title}</h1>
              <div
                class="text-white small"
                dangerouslySetInnerHTML={{
                  __html: course.banner_description,
                }}
              ></div>
              <div className="row mx-0 mb-3">
                <Row className="info-line w-auto">
                  <i class="ti ti-file-spark me-2 align-self-center"></i>
                  <p className="text-white">{course.level}</p>
                </Row>
                <Row className="info-line w-auto">
                  <i class="ti ti-file-report me-2 align-self-center"></i>
                  <p className="text-white">{course.duration}</p>
                </Row>
                <Row className="info-line w-auto">
                  <i class="ti ti-file-text-shield me-2 align-self-center col-auto"></i>
                  <p className="text-white col-11">{course.eligibility}</p>
                </Row>
              </div>
              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-apply me-2"
                  onClick={() => setModalShow(true)}
                >
                  Apply Now
                </button>
                <EnquiryNow
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
                <a
                  onClick={(e) => {
                    e.preventDefault(); // stop auto-download
                    setModalShow(true); // open modal instead
                  }}
                  className="btn btn-download"
                  href={Brochure} // keep reference
                  target="_blank"
                  download="ISBM_PROSPECTUS.pdf"
                >
                  Download Brochure
                </a>
              </div>
            </div>
          </div>
        </div>

        <section className="ptb-50 text-center">
          <div className="container-xxl">
            <div className="text-center mb-5">
              <h2 className="text-blue section-title modern-title">Overview</h2>
            </div>
            <div
              class="overview"
              dangerouslySetInnerHTML={{
                __html: course.description,
              }}
            ></div>
          </div>
        </section>

        <section class="py-5 bg-purple text-white text-center">
          <h2>Transform Your Tomorrow</h2>
          <p class="w-50 m-auto text-center my-4">
            Unlock endless possibilities and shape your future today. Transform
            your tomorrow with the education that empowers you to achieve
            greatness.
          </p>
          <button
            type="button"
            class="btn btn-sm btn-download px-5 me-2"
            onClick={() => setModalShow2(true)}
          >
            Apply Now
          </button>
          <EnquiryNow show={modalShow2} onHide={() => setModalShow2(false)} />
        </section>

        {specializationItems.length > 0 && (
          <section className="course-specializations ptb=100">
            <div className="container-xxl">
              <div id="specializations" className="specializations py-5">
                <h2 className="text-blue text-center section-title modern-title">
                  Specializations Offered
                </h2>
                <h4 className="text-center mb-3">
                  {course.specialization_selection}
                </h4>
                <ul className="row mt-4">
                  {Array.from(specializationItems).map((item, index) => (
                    <li key={index} className="col-lg-4 col-md-4 col-sm-12">
                      {item.textContent}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        )}

        <section className="ptb-50 color-section">
          <div className="container-xxl">
            <div className="text-center mb-5">
              <h2 className="text-blue section-title modern-title">
                Course Outcomes
              </h2>
            </div>
            <div
              class="overview"
              dangerouslySetInnerHTML={{
                __html: course.outcome,
              }}
            ></div>
          </div>
        </section>

        <section className="container py-5">
          <div className="coList row mx-0 mt-30">
            <div className="col-lg-5 col-12">
              <div className="coCol1">
                <figure>
                  <h2 className="black_title">Career Opportunities</h2>
                  <figcaption className="blockquote-footer mt-2 mb-4">
                    Uncover the findings from your studies
                  </figcaption>
                </figure>
                <p>
                  Explore a world of career opportunities that align with your
                  passions. Unlock doors to success with the right skills and
                  guidance.
                </p>
              </div>
            </div>
            <div className="col-lg-7 col-12">
              <h2 className="text-blue text-center section-title modern-title">
                Future-Ready Opportunities
              </h2>
              <ul className="row mt-4">
                {careerList && careerList.length > 0 ? (
                  careerList.map((careers) => (
                    <li className="col-lg-6 col-md-6 col-12 p-2" key={careers}>
                      <div className="coListLi">{careers}</div>
                    </li>
                  ))
                ) : (
                  <li>No career opportunities available</li>
                )}
              </ul>
            </div>
          </div>
        </section>
        <Allinone />
        <Footer />
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="video_courses_abcdsa"
        >
          <Modal.Body className="p-0 bg-transparent">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/jgS_lbVI428"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    )
  );
};

export default CourseDetails;
